import { useContext, useEffect } from "react";

import { AuthContext } from "~/auth/AuthProvider";
import resolveSessionIdentity from "~/helpers/persistedSessionIdentity";
import { useAppDispatch, useAppSelector } from "~/hooks/reduxHooks";
import { establishSessionIdentity, invalidateIdentity } from "~/store/pendingIntentSlice";

const useContinuationIdentityFence = (): void => {
	const dispatch = useAppDispatch();
	const { currentUser, loggedIn } = useContext(AuthContext);
	const signedInEmail = currentUser?.email;
	const tenantId = useAppSelector((state) => state.settings.tenantId);
	const storedIdentity = useAppSelector((state) => state.pendingIntent.identity);

	useEffect(() => {
		const { userEmail } = resolveSessionIdentity();
		if (!loggedIn || !signedInEmail || !userEmail || !tenantId) {
			if (storedIdentity) dispatch(invalidateIdentity());
			return;
		}
		if (storedIdentity?.accountEmail === userEmail && storedIdentity.tenantId === tenantId) return;
		dispatch(establishSessionIdentity({ accountEmail: userEmail, tenantId }));
	}, [loggedIn, signedInEmail, storedIdentity, tenantId]);
};

export default useContinuationIdentityFence;
